module.exports = __webpack_public_path__ + "img/old_plus_active.df012683.svg";